import { getIsRtlLang } from 'forms-utils-lib/language/getIsRtlLang';
export const getIsSwitchingBetweenFormattingModes = (oldLang, newLang) => getIsRtlLang(oldLang) !== getIsRtlLang(newLang);